<div class="card card-custom gutter-b card-fit" data-card="true" id="kt_card_1">
    <div class="card-header">
        <div class="card-title">

        </div>
        <div class="card-toolbar"> 

            <button type="button" class="btn btn-sm btn-primary font-weight-bold" (click)="add()">
                <!--begin::Svg Icon | path: icons/duotune/general/gen031.svg-->
                <i class="fas fa-plus icon-sm"></i>Add Contact
            </button>
        </div>
    </div>
    <div class="card-body  mt-0 py-0 px-5">

        <div class="table-responsive max-h-500px">
            <table class="table table-bordered  table-sm rounded">
                <thead class="thead-light">
                    <tr>
                        <th>Contact</th>
                        <th>Phone Number</th>
                        <th>Default</th>
                        <th class="min-w-100px text-center">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="clientService.client_contact.length === 0">
                        <td colspan="3">No information available</td>
                    </tr>
                    <tr *ngFor="let item of clientService.client_contact">

                        <td>
                            <span class="text-dark text-hover-primary font-size-lg" (click)="edit(item)">
                                {{ item.contact_desc }}
                            </span>
                        </td>

                        <td>
                            {{ item.contact_no | formatPhoneNumber }} {{ item.contact_ext }}
                        </td>
                        <td>
                            {{ item._default ? 'Yes' : 'No' }}
                        </td>
                        <td class="pr-0 text-center">
                            <button type="button" class="btn btn-icon btn-secondary btn-sm mx-1 my-0"
                                (click)="edit(item)">
                                <i class="la la-pen"></i>
                            </button>
                            <button type="button" class="btn btn-icon btn-danger btn-sm btn-hover-danger my-0 mx-1"
                                (click)="delete(item)">
                                <i class="la la-trash"></i>
                            </button>
                        </td>
                    </tr>

                </tbody>
            </table>
        </div>
    </div>
</div>